import i18next from "i18next";
// Coin value math mirror of backend services/coins.py. 1 coin = $0.20 fixed.
// The dollar figure is always DERIVED from coins so the two can never drift.
export const COIN_CENTS = 20;

export const coinsForCents = (cents) => Math.ceil((Number(cents) || 0) / COIN_CENTS);
// Exact coin value of a BALANCE or a completed amount (never rounded). Cents/20 is a
// multiple of 0.05, so at most 2 decimals; whole values stay whole. Prices keep coinsForCents.
export const coinsExact = (cents) => Math.round((Number(cents) || 0) / COIN_CENTS * 100) / 100;
// i18n options for a coin COUNT: `count` picks the plural form only and is never printed;
// the printed value is locale-formatted (decimal separator, Latin digits, max 2 decimals).
export const formatCoins = (v) => new Intl.NumberFormat(i18next.language || "en", { numberingSystem: "latn", maximumFractionDigits: 2 }).format(Number(v) || 0);
export const coinVars = (v) => ({ count: Number(v) || 0, coins: formatCoins(v) });
export const balanceVars = (v) => ({ count: Number(v) || 0, balance: formatCoins(v) });
export const coinsForDollars = (dollars) => coinsForCents(Math.round((Number(dollars) || 0) * 100));
export const centsForCoins = (coins) => (Number(coins) || 0) * COIN_CENTS;
export const dollarsForCoins = (coins) => centsForCoins(coins) / 100;
export const isOnCoinBoundaryCents = (cents) => (Number(cents) || 0) % COIN_CENTS === 0;

// Format a derived dollar value. Whole dollars drop the cents for a cleaner line.
export const formatDollars = (dollars) => {
  const n = Number(dollars) || 0;
  return Number.isInteger(n) ? `$${n}` : `$${n.toFixed(2)}`;
};
